import {API} from "../api/axios";
const END_POINT = "/school-exam";
const END_POINT_EXAM = "/school-exams";
const END_POINT_EXAM_CALND = "/exam-stats";
const END_POINT_EXAM_FILTER = "/exam-filter";
class ExamScheduleService {
  getAll(params) {
    return API.get(END_POINT_EXAM, params);
  }
  getFilter(params) {
    return API.get(END_POINT_EXAM_FILTER, params);
  }
  get(id) {
    return API.get(`${END_POINT}/${id}`);
  }
  delete(id) {
    return API.delete(`${END_POINT}/${id}`);
  }
  create(data) {
    return API.post(END_POINT, data);
  }
  update(id, data) {
    return API.post(`${END_POINT}/${id}`, data);
  }
  getCalender(params) {
    return API.get(END_POINT_EXAM_CALND, params);
  }
}

export default new ExamScheduleService();
